import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IInspectionItem, InspectionImages } from '../../models/response/InspectionResponse';

import { IInspection } from './inspection';

const initialState: IInspection.TInitialState = {
  token: null,
  currentCar: null,
  currentImage: null,
};

const inspection = createSlice({
  name: 'inspection',
  initialState,
  reducers: {
    setToken: (state, action: PayloadAction<string | null>) => {
      state.token = action.payload;
    },
    setCurrentCar: (state, action: PayloadAction<IInspectionItem | null>) => {
      state.currentCar = action.payload;
    },
    setCurrentImage: (state, action: PayloadAction<InspectionImages | null>) => {
      state.currentImage = action.payload;
    },
  },
});

export const { setToken, setCurrentCar, setCurrentImage } = inspection.actions;

export default inspection.reducer;
